module.exports = __webpack_public_path__ + "06eb99bf6758ffa4d0efda2f1c496c74.svg";